import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';

export const searchByImage = (
  imageBase64: string,
  pageSize: string = '10',
  currentPage: string = '1',
  apiVersion: string = 'v1',
  imageExtension: string = 'png'
) => {
  // Create a FormData object for proper encoding
  const requestBody = {
    api_version: apiVersion,
    PageSize: pageSize,
    currentPage: currentPage,
    image_extension: imageExtension,
    image: imageBase64,
  };

  const url = getUrl(ROUTES.IMAGE_SEARCH);
  return ApiHelper(url, {
    method: 'POST',
    body: requestBody,
    headers: {
      Platform: 'web',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    isBodyJSON: false, // Let ApiHelper encode to x-www-form-urlencoded
  }).then(async (response) => {
    if (!response.ok) {
      return Promise.reject({
        message: response.status,
        statusText: response.statusText,
        statusCode: response.status,
      });
    }
    const res = await response.json();
    if (res.status !== 'success') {
      return Promise.reject(res);
    }

    return res.response.products || [];
  });
};
